import { createFileRoute } from '@tanstack/react-router'
import { StationClosuresPage } from '@/pages/station-closures'

export const Route = createFileRoute('/_authenticated/closures')({
  component: StationClosuresPage,
})